export const EventFilterTranslation = {
  fi: {
    EventFilter: {
      userId: 'Laitekäyttäjä',
      deviceId: 'Laite',
      userTag: 'Tagin UID-tunnus',
    },
  },
};
